import type { RenderSnapshot } from './RendererInterface';
import { scoreDisplay } from '../game/scoring';
import { P } from './palette';
import { text } from './font';
import { drawFrog } from './sprites';
export function hud(ctx:CanvasRenderingContext2D,e:RenderSnapshot):void {
  text(ctx,'1-UP',7,1,P.white);text(ctx,'HI-SCORE',80,1,P.white);text(ctx,'2-UP',190,1,P.white);
  text(ctx,scoreDisplay(e.score),6,11,P.red);text(ctx,scoreDisplay(e.highScore),89,11,P.red);text(ctx,'00000',188,11,P.red);
  for(let i=0;i<Math.min(7,Math.max(0,e.lives-1));i++)drawFrog(ctx,8+i*13,244,'up',false,false,0.65);
  text(ctx,`L${e.level}`,188,240,P.yellow);
  const width=Math.ceil(e.timer.ratio*112);
  ctx.fillStyle=e.timer.beats<=10?P.red:P.green;ctx.fillRect(174-width,250,width,5);
  text(ctx,'TIME',180,249,P.yellow);
}
